var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isBarChartVisible || _vm.isCustomBarChartVisible || _vm.isCustomBarChartQuizTypeVisible)?_c('div',{staticClass:"w-full h-full d-flex"},[(_vm.isQuestionImageEnabled)?_c('QuestionImage',{class:{
      'default-canvas-image-width': !_vm.slideActive.showFullImageQuestion,
      'full-canvas-image-width' : _vm.slideActive.showFullImageQuestion,
      'hide-canvas-image': !_vm.questionHasImageXLarge,
    },on:{"expandCollapseTrigger":_vm.updateQuestionImageLayoutMode}}):_vm._e(),_c(_vm.chartName,{tag:"component",staticClass:"default-chart-width",class:{
      'default-chart-with-image' : _vm.isQuestionImageAndHasImageXLargeEnabled,
      'full-chart' : _vm.slideActive.showFullImageQuestion,
    }})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }